<template>

  <div
    class="card-section"
  >
    <div class="card-section-header">
      <div class="card-section-header-name">
        {{ $companyConfiguration.cascading.getSectionShowName() }}
      </div>


      <router-link
        target="_blank"
        :to="{ name: 'CascadingElements' }"
      >
        <el-button
          style="margin-left:30px; display: inline-block"
          size="mini"
        >
          Управление каскадированием
        </el-button>
      </router-link>


      <el-alert
        v-if="websocket.state === 3"
        style="width: 700px; display: inline-table; margin-left: 30px"
        title="Внимание. Невозможно подключиться к Web Socket. Данные могут быть не синхронизированы"
        type="error"
        show-icon
      ></el-alert>
    </div>


    <el-table
      ref="CascadingCardSectionTable"
      class="card-section-elements-table"
      header-row-class-name="card-section-elements-table-header"
      :show-header="!!nodes.length"
      style="width: 100%"
      border
      :max-height="maxHeightOfSection"
      size="mini"
      :empty-text="$companyConfiguration.cascading.getSectionEmptyText()"

      :data="nodes"
      row-key="id"
      lazy
      :load="loadTreeNode"
      :tree-props="{hasChildren: 'hasChildren'}"
      v-loading="loading"
    >
      <component
        v-for="(columnConfig, index) in columnsConfigs"
        v-if="ifShowColumn(columnConfig)"
        :is="columnConfig.manualColumnTemplate ? columnConfig.template : baseTableColumn"
        :key="index"
        :column-config="columnConfig"
      >
      </component>
    </el-table>
<!--        @elements-changed="elementsChanged"-->

  </div>
</template>


<script>

import ClickToEdit from "@/components/ClickToEdit.vue";
import { mapGetters } from "vuex";
import CascadingScalePerformanceValuesInput
  from "@/modules/cascading/components/scale/CascadingScalePerformanceValuesInput.vue";
import ElementsTreeNode from "@/modules/cascading/components/ElementsTree/ElementsTreeNodeClass";
import WSClient from "@/components/webSocket/WSClient";
import CascadingScaleUnitSelect from "@/modules/cascading/components/scale/CascadingScaleUnitSelect.vue";

export default {
  name: 'CascadingCardSection',
  components: { CascadingScaleUnitSelect, CascadingScalePerformanceValuesInput, ClickToEdit },
  props: {},

  computed: {
    ...mapGetters(['user']),
    ...mapGetters('card', {
      card: 'card',
    }),
    ...mapGetters('card/stages', {
      stages: 'stages',
      currentStage: 'currentStage',
      currentNegotiation: 'currentNegotiation',
    }),
    ...mapGetters('card/cascadingSection', {
      loading: 'loading',
      nodes: 'nodes',
    }),
    baseTableColumn() {
      return () => import(`@/components/tableColumnTemplates/BaseTableColumn`);
    },
  },

  beforeMount() {
    this.columnsConfigs = this.$companyConfiguration.helpers.getTableColumnsArrayFromConfig(
      this.$companyConfiguration.cascading.getSectionColumns()
    );
  },
  mounted() {
    this.maxHeightOfSection = window.innerHeight - 100;
    this.loadCardElements();
    this.initWebSocket();
  },
  data() {
    return {
      websocket: {},
      maxHeightOfSection: null,
      columnsConfigs: [],
    }
  },

  methods: {
    initWebSocket(){
      this.websocket = new WSClient('cascading');
      // this.websocket.on('TreeElementCreated', this.elementCreatedReceived);
      this.websocket.on('TreeElementUpdated', this.elementNewDataReceived);
      // this.websocket.on('TreeElementDeleted', this.elementDeletedReceived);
      this.websocket.connect();
    },

    loadCardElements() {
      this.$store.dispatch('card/cascadingSection/loadElements',{
        card_id: this.card.id,
        expand: 'scale,parent_links,parent_links.parent_element,has_children, card.user',
      })
    },

    loadTreeNode(node, treeNode, resolve) {
      node.loadChildren()
        .then(() => {
          resolve(node.childrenNodes)
        })
    },

    elementNewDataReceived(elementData){
      this.$store.dispatch('card/cascadingSection/elementNewDataReceived',{
        elementData: elementData,
      })
    },




    ifShowColumn(columnConfig){
      if( !columnConfig.getVif(this) ){
        return false;
      }

      if( columnConfig.showOnStages ){
        if( this.card.status === this.$constants.card.statuses.STATUS_COMPLETED ){
          return columnConfig.showOnCompleted;
        }

        // У нас может совпасть stage, но у этого stage может не быть еще активного negotiation.
        // Поэтому нужно проверить не только stage, но и наличие активного negotiation
        // НО! Может быть так, что колонка должна быть на этапе без проверки negotiation
        // Например Промежуточное выполнение на этапе оценки. Если нет активного шага на оценке,
        // То и колонка не будет видна, хотя она заполнялась на предыдущем этапе
        // Для этого ввели showOnStagesWhileNoNegotiation,
        // где можно перечислить, для каких этапов мы пропускаем проверку активного шага
        if( !this.currentNegotiation ){
          const showWhileNoNegotiation = columnConfig.showOnStagesWhileNoNegotiation ? columnConfig.showOnStagesWhileNoNegotiation : [];
          return showWhileNoNegotiation.includes(this.currentStage?.type)
        }

        return columnConfig.showOnStages.includes(this.currentStage?.type);
      }

      return true;
    },





  }
}
</script>

<style scoped lang="scss">
@import "@/assets/css/project-variables";

.card-section {
  margin-bottom: 30px;

  &-header {
    font-weight: bold;
    margin-bottom: 5px;

    &-name {
      display: inline-block;
      min-width: 100px;
    }
  }
}

</style>